import { render, staticRenderFns } from "./dome.vue?vue&type=template&id=5ba262dc&scoped=true&"
import script from "./dome.vue?vue&type=script&setup=true&lang=js&"
export * from "./dome.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./dome.vue?vue&type=style&index=0&id=5ba262dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba262dc",
  null
  
)

export default component.exports